/* eslint-disable no-shadow */
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["checkout_incomplete"] = "checkout_incomplete";
    PaymentStatus["checkout_complete"] = "checkout_complete";
    PaymentStatus["checkout_declined"] = "checkout_declined";
    PaymentStatus["checkout_failed"] = "checkout_failed";
    PaymentStatus["checkout_voided"] = "checkout_voided";
    PaymentStatus["checkout_refunded"] = "checkout_refunded";
    PaymentStatus["checkout_authorized"] = "checkout_authorized";
    PaymentStatus["checkout_started"] = "checkout_started";
})(PaymentStatus || (PaymentStatus = {}));
var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["EMPTY"] = "EMPTY";
    PaymentProvider["DINTERO"] = "DINTERO";
    PaymentProvider["LEID"] = "LEID";
    PaymentProvider["OPERATOR"] = "OPERATOR";
    PaymentProvider["SYSTIMA"] = "SYSTIMA";
    PaymentProvider["POWEROFFICE"] = "POWEROFFICE";
    PaymentProvider["MANUAL_REFUND"] = "MANUAL_REFUND";
    PaymentProvider["OPERATOR_INVOICE"] = "OPERATOR_INVOICE";
    PaymentProvider["HYGGLO"] = "HYGGLO";
})(PaymentProvider || (PaymentProvider = {}));
var PaymentEventType;
(function (PaymentEventType) {
    PaymentEventType["CREATE"] = "CREATE";
    PaymentEventType["UPDATE"] = "UPDATE";
})(PaymentEventType || (PaymentEventType = {}));
var OrderOrigin;
(function (OrderOrigin) {
    OrderOrigin["LEID"] = "LEID";
    OrderOrigin["MANAGER"] = "MANAGER";
})(OrderOrigin || (OrderOrigin = {}));
var ReconciliationProcessingStatus;
(function (ReconciliationProcessingStatus) {
    ReconciliationProcessingStatus["PREPARING"] = "PREPARING";
    ReconciliationProcessingStatus["PENDING"] = "PENDING";
    ReconciliationProcessingStatus["COMPLETED"] = "COMPLETED";
})(ReconciliationProcessingStatus || (ReconciliationProcessingStatus = {}));
var ReconciliationType;
(function (ReconciliationType) {
    ReconciliationType["GENERAL"] = "GENERAL";
    ReconciliationType["DISCOUNT"] = "DISCOUNT";
    ReconciliationType["ADJUSTMENT"] = "ADJUSTMENT";
})(ReconciliationType || (ReconciliationType = {}));
var LedgerType;
(function (LedgerType) {
    LedgerType["PRIMARY"] = "PRIMARY";
    LedgerType["SECONDARY"] = "SECONDARY";
})(LedgerType || (LedgerType = {}));
var LedgerStatus;
(function (LedgerStatus) {
    LedgerStatus["SENT"] = "SENT";
    LedgerStatus["REVERTED"] = "REVERTED";
})(LedgerStatus || (LedgerStatus = {}));
var ReconciliationAccountingType;
(function (ReconciliationAccountingType) {
    ReconciliationAccountingType["LEID"] = "LEID";
    ReconciliationAccountingType["LEID_RENTAL"] = "LEID_RENTAL";
    ReconciliationAccountingType["FRANCHISEE"] = "FRANCHISEE";
    ReconciliationAccountingType["SAAS"] = "SAAS";
    ReconciliationAccountingType["REQUEST"] = "REQUEST";
})(ReconciliationAccountingType || (ReconciliationAccountingType = {}));
var DiscountCodeLogEventType;
(function (DiscountCodeLogEventType) {
    DiscountCodeLogEventType["CREATED"] = "CREATED";
    DiscountCodeLogEventType["USED"] = "USED";
    DiscountCodeLogEventType["UPDATED"] = "UPDATED";
    DiscountCodeLogEventType["DELETED"] = "DELETED";
    DiscountCodeLogEventType["ERROR"] = "ERROR";
})(DiscountCodeLogEventType || (DiscountCodeLogEventType = {}));
var LicenseType;
(function (LicenseType) {
    LicenseType["PLATFORM_LICENSE"] = "PLATFORM_LICENSE";
    LicenseType["PARTNER_PORTAL_LICENSE"] = "PARTNER_PORTAL_LICENSE";
    LicenseType["LOCATION_LICENSE"] = "LOCATION_LICENSE";
    LicenseType["SELFSERVICE_LICENSE"] = "SELFSERVICE_LICENSE";
    LicenseType["PADLOCK_LICENSE"] = "PADLOCK_LICENSE";
    LicenseType["GPS_LICENSE"] = "GPS_LICENSE";
    LicenseType["FINANCING"] = "FINANCING";
})(LicenseType || (LicenseType = {}));
var SellerApprovalStatus;
(function (SellerApprovalStatus) {
    SellerApprovalStatus["ACTIVE"] = "ACTIVE";
    SellerApprovalStatus["DECLINED"] = "DECLINED";
    SellerApprovalStatus["UNDER_MANUAL_REVIEW"] = "UNDER_MANUAL_REVIEW";
    SellerApprovalStatus["AUTOMATIC_REVIEW"] = "AUTOMATIC_REVIEW";
    SellerApprovalStatus["WAITING_FOR_SIGNATURE"] = "WAITING_FOR_SIGNATURE";
    SellerApprovalStatus["WAITING_FOR_DECLARATION"] = "WAITING_FOR_DECLARATION";
    SellerApprovalStatus["ERROR"] = "ERROR";
    SellerApprovalStatus["ARCHIVED"] = "ARCHIVED";
    SellerApprovalStatus["WAITING_FOR_DETAILS"] = "WAITING_FOR_DETAILS";
})(SellerApprovalStatus || (SellerApprovalStatus = {}));

export { DiscountCodeLogEventType, LedgerStatus, LedgerType, LicenseType, OrderOrigin, PaymentEventType, PaymentProvider, PaymentStatus, ReconciliationAccountingType, ReconciliationProcessingStatus, ReconciliationType, SellerApprovalStatus };
//# sourceMappingURL=enums.js.map
